export default __webpack_public_path__ + "ac96061fb526a569395c377cf944540b.png";